import { useRef, useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";
import Form_Header from "../../../common/form-header/Form_Header";
import "./Create_Step3.css";
import Preview_Modal from "../../../common/common-modal/preview-modal/Preview_Modal";
import { useRegistration } from "../../../../context/RegistrationContext";
import { submitStep3, getRegistrationProgress } from "../../../../utils/gymOwnerApi";

const Create_Step3 = ({ step, totalSteps, setStep }) => {
  const { userId, setRegistrationData } = useRegistration();
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const { control, handleSubmit, formState: { errors }, setValue } = useForm({
    defaultValues: {
      gst_number: "",
      pan_card_number: "",
      bank_name: "",
      account_holder_name: "",
      account_number: "",
      ifsc_code: "",
    },
  });
  const [showDocs, setShowDocs] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [bankDetails, setBankDetails] = useState({
    bank_name: "",
    account_holder_name: "",
    account_number: "",
    ifsc_code: "",
  });

  const fileRefs = {
    shopAct: useRef(null),
    gst: useRef(null),
    salesTax: useRef(null),
    itr: useRef(null),
  };

  const [files, setFiles] = useState({
    shopAct: null,
    gst: null,
    salesTax: null,
    itr: null,
  });
  const singleFileRef = useRef(null);
  const [singleFile, setSingleFile] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [modalFile, setModalFile] = useState(null);
  useEffect(() => {
    const loadProgress = async () => {
      if (userId) {
        setLoadingData(true);
        try {
          const response = await getRegistrationProgress();
          if (response.success && response.data) {
            const gstDetail = response.data.gst_detail;
            const bankDetail = response.data.bank_detail;
            if (gstDetail) {
              setValue("gst_number", gstDetail.gst_number || "");
              setValue("pan_card_number", gstDetail.pan_card_number || "");
            }
            if (bankDetail) {
              setValue("bank_name", bankDetail.bank_name || "");
              setValue("account_holder_name", bankDetail.account_holder_name || "");
              setValue("account_number", bankDetail.account_number || "");
              setValue("ifsc_code", bankDetail.ifsc_code || "");
              setBankDetails({
                bank_name: bankDetail.bank_name || "",
                account_holder_name: bankDetail.account_holder_name || "",
                account_number: bankDetail.account_number || "",
                ifsc_code: bankDetail.ifsc_code || "",
              });
            }
            setRegistrationData(response.data);
          }
        } catch (error) {
          console.error("Error loading progress:", error);
        } finally {
          setLoadingData(false);
        }
      }
    };
    loadProgress();
  }, [userId, setValue, setRegistrationData]);

  const onSubmit = async (data) => {
    if (!userId) {
      alert("Please complete previous steps first");
      setStep(1);
      return;
    }

    setLoading(true);
    try {
      const step3Data = {
        user_id: userId,
        gst_number: data.gst_number,
        pan_card_number: data.pan_card_number,
        bank_name: data.bank_name,
        account_holder_name: data.account_holder_name,
        account_number: data.account_number,
        ifsc_code: data.ifsc_code,
      };
      const res = await submitStep3(step3Data);

      setStep(4);
    } catch (error) {
      console.error("Error submitting step 3:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleFileChange = (type, e) => {
    const file = e.target.files[0];
    if (file) {
      setFiles((prev) => ({
        ...prev,
        [type]: {
          file,
          name: file.name,
          preview: URL.createObjectURL(file),
        },
      }));
    }
  };

  const handleSingleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSingleFile({
        file,
        name: file.name,
        preview: URL.createObjectURL(file),
      });
    }
  };

  const handlePreview = (file) => {
    setModalFile(file);
    setModalShow(true);
  };

  const handleFileButtonClick = (type) => {
    if (files[type]?.preview) {
      handlePreview(files[type]);
    } else {
      fileRefs[type].current.click();
    }
  };

  const handleSingleButtonClick = () => {
    if (singleFile?.preview) {
      handlePreview(singleFile);
    } else {
      singleFileRef.current.click();
    }
  };

  if (showDocs) {
    return (
      <section className="step3_wrapper step1_wrapper">
        <Form_Header
          title="Legal Proofs & Compliance"
          subtitle=""
          step={3}
          totalSteps={6}
        />
        <div className="container mt-4">
          <div className="doc_header">
            <h5 className="doc_title">{selectedType}</h5>
            <span className="doc_info">
              Any 2 of the following: Shop Act License, GST Certificate, Sales
              Tax/Service Tax Registration, or complete ITR.
            </span>
          </div>
          <h5 className="doc_back" onClick={() => setShowDocs(false)}>
            Back
          </h5>

          <div className="row mt-4">
            {[
              { label: "Shop Act License", key: "shopAct" },
              { label: "GST Certificate", key: "gst" },
              { label: "Sales Tax/Service Tax Registration", key: "salesTax" },
              { label: "ITR", key: "itr" },
            ].map((item) => (
              <div className="col-lg-6 mb-4" key={item.key}>
                <Form.Group>
                  <Form.Label>{item.label}</Form.Label>

                  <div className="file_upload_wrapper">
                    <span className="file_placeholder">
                      {files[item.key] ? files[item.key].name : "No File Uploaded"}
                    </span>

                    <div
                      className="upload_btn"
                      onClick={() => handleFileButtonClick(item.key)}
                    >
                      <Common_Btn
                        btnText={files[item.key] ? "Preview" : "Upload file"}
                      />
                    </div>

                    <input
                      ref={fileRefs[item.key]}
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={(e) => handleFileChange(item.key, e)}
                    />
                  </div>
                </Form.Group>
              </div>
            ))}
          </div>

          <div className="text-center mt-4 form_btn_holder">
            <Common_Btn btnText={"Done"} onClick={() => setShowDocs(false)} />
          </div>
        </div>

        {/* Document Modal */}
        <Preview_Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          file={modalFile}
          onUploadNew={() => {
            if (modalFile === singleFile) {
              singleFileRef.current.click();
            } else {
              const key = Object.keys(files).find((k) => files[k] === modalFile);
              fileRefs[key].current.click();
            }
          }}
          onDelete={() => {
            if (modalFile === singleFile) {
              setSingleFile(null);
            } else {
              const key = Object.keys(files).find((k) => files[k] === modalFile);
              setFiles((prev) => ({ ...prev, [key]: null }));
            }
            setModalShow(false);
          }}
        />
      </section>
    );
  }
  return (
    <section className="step3_wrapper step1_wrapper">
      <Form_Header
        title="Legal Proofs & Compliance"
        subtitle=""
        step={3}
        totalSteps={7}
      />

      <div className="container">
        {loadingData ? (
          <div className="text-center py-5">
            <p>Loading saved data...</p>
          </div>
        ) : (
          <Form className="auth_form" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">

              {/* GST Number */}
              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>GST Number *</Form.Label>
                  <Controller
                    name="gst_number"
                    control={control}
                    rules={{
                      required: "GST number is required",
                      pattern: {
                        value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                        message: "Invalid GST number (e.g. 27ABCDE1234F1Z5)",
                      },
                      minLength: { value: 15, message: "GST must be exactly 15 characters" },
                      maxLength: { value: 15, message: "GST must be exactly 15 characters" },
                    }}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Enter GST Number (e.g. 27ABCDE1234F1Z5)"
                        maxLength={15}
                        {...field}
                        onChange={(e) => {
                          e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                          field.onChange(e);
                        }}
                        onKeyPress={(e) => {
                          if (!/[A-Za-z0-9]/.test(e.key)) e.preventDefault();
                          if (e.target.value.length >= 15) e.preventDefault();
                        }}
                        onPaste={(e) => {
                          const pasted = e.clipboardData.getData("text").toUpperCase();
                          if (!/^[A-Z0-9]+$/.test(pasted)) e.preventDefault();
                        }}
                      />
                    )}
                  />
                </Form.Group>
                <div className="text-danger">{errors.gst_number?.message}</div>
              </div>

              {/* PAN Card Number */}
              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>PAN Card Number *</Form.Label>
                  <Controller
                    name="pan_card_number"
                    control={control}
                    rules={{
                      required: "PAN card number is required",
                      pattern: {
                        value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                        message: "Invalid PAN (e.g. ABCDE1234F)",
                      },
                      minLength: { value: 10, message: "PAN must be exactly 10 characters" },
                      maxLength: { value: 10, message: "PAN must be exactly 10 characters" },
                    }}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Enter PAN Card Number (e.g. ABCDE1234F)"
                        maxLength={10}
                        {...field}
                        onChange={(e) => {
                          e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                          field.onChange(e);
                        }}
                        onKeyPress={(e) => {
                          const val = e.target.value;
                          const len = val.length;
                          const isLetter = /[A-Za-z]/.test(e.key);
                          const isDigit = /[0-9]/.test(e.key);
                          if (len < 5 && !isLetter) e.preventDefault();
                          if (len >= 5 && len < 9 && !isDigit) e.preventDefault();
                          if (len === 9 && !isLetter) e.preventDefault();
                          if (len >= 10) e.preventDefault();
                        }}
                        onPaste={(e) => {
                          const pasted = e.clipboardData.getData("text").toUpperCase();
                          if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pasted)) e.preventDefault();
                        }}
                      />
                    )}
                  />
                  <div className="text-danger">{errors.pan_card_number?.message}</div>
                </Form.Group>
              </div>

              {/* Bank Name */}
              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>Bank Name *</Form.Label>
                  <Controller
                    name="bank_name"
                    control={control}
                    rules={{
                      required: "Bank name is required",
                      minLength: { value: 3, message: "Bank name must be at least 3 characters" },
                      maxLength: { value: 20, message: "Bank name must be less than 20 characters" },
                    }}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Enter Bank Name"
                        {...field}
                        onKeyPress={(e) => {
                          if (!/[A-Za-z ]/.test(e.key)) e.preventDefault();
                        }}
                      />
                    )}
                  />
                  <div className="text-danger">{errors.bank_name?.message}</div>
                </Form.Group>
              </div>

              {/* Account Holder Name */}
              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>Account Holder Name *</Form.Label>
                  <Controller
                    name="account_holder_name"
                    control={control}
                    rules={{
                      required: "Account holder name is required",
                      minLength: { value: 3, message: "Name must be at least 3 characters" },
                      maxLength: { value: 20, message: "name must be less than 20 characters" },

                      pattern: {
                        value: /^[A-Za-z\s]+$/,
                        message: "Only letters allowed",
                      },
                    }}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Enter Account Holder Name"
                        {...field}
                        onKeyPress={(e) => {
                          if (!/[A-Za-z ]/.test(e.key)) e.preventDefault();
                        }}
                      />
                    )}
                  />
                  <div className="text-danger">{errors.account_holder_name?.message}</div>
                </Form.Group>
              </div>

              {/* Account Number */}
              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>Account Number *</Form.Label>
                  <Controller
                    name="account_number"
                    control={control}
                    rules={{
                      required: "Account number is required",
                      pattern: {
                        value: /^[0-9]+$/,
                        message: "Only digits allowed",
                      },
                      minLength: {
                        value: 9,
                        message: "Account number must be at least 9 digits",
                      },
                      maxLength: {
                        value: 18,
                        message: "Account number cannot exceed 18 digits",
                      },
                      validate: {
                        noAllSame: (v) =>
                          !/^(.)\1+$/.test(v) || "Cannot be all same digits",
                        noLeadingZero: (v) =>
                          v[0] !== "0" || "Cannot start with 0",
                      },
                    }}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Enter Account Number"
                        maxLength={18}
                        {...field}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) e.preventDefault();
                          if (e.target.value.length >= 18) e.preventDefault();
                        }}
                        onPaste={(e) => {
                          const pasted = e.clipboardData.getData("text");
                          if (!/^[0-9]+$/.test(pasted)) e.preventDefault();
                        }}
                      />
                    )}
                  />
                  <div className="text-danger">{errors.account_number?.message}</div>
                </Form.Group>
              </div>

              {/* IFSC Code */}
              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>IFSC Code *</Form.Label>
                  <Controller
                    name="ifsc_code"
                    control={control}
                    rules={{
                      required: "IFSC code is required",
                      pattern: {
                        value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                        message: "Invalid IFSC code (e.g. SBIN0001234)",
                      },
                      minLength: { value: 11, message: "IFSC must be exactly 11 characters" },
                      maxLength: { value: 11, message: "IFSC must be exactly 11 characters" },
                    }}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Enter IFSC Code (e.g. SBIN0001234)"
                        maxLength={11}
                        {...field}
                        onChange={(e) => {
                          e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                          field.onChange(e);
                        }}
                        onKeyPress={(e) => {
                          if (!/[A-Za-z0-9]/.test(e.key)) e.preventDefault();
                          if (e.target.value.length >= 11) e.preventDefault();
                        }}
                        onPaste={(e) => {
                          const pasted = e.clipboardData.getData("text").toUpperCase();
                          if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(pasted)) e.preventDefault();
                        }}
                      />
                    )}
                  />
                  <div className="text-danger">{errors.ifsc_code?.message}</div>
                </Form.Group>
              </div>


            </div>
          </Form>
        )}

        <div className="form_btn_holder">
          {!loading && <>
            <White_Btn btnText={"Back"} onClick={() => setStep(2)} />
            <Common_Btn
              btnText={loading ? "Submitting..." : "Next"}
              onClick={handleSubmit(onSubmit)}
              disabled={loading}
            />
          </>}
        </div>

        {/* Document Modal */}
        <Preview_Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          file={modalFile}
          onUploadNew={() => {
            if (modalFile === singleFile) {
              singleFileRef.current.click();
            } else {
              const key = Object.keys(files).find((k) => files[k] === modalFile);
              fileRefs[key].current.click();
            }
          }}
          onDelete={() => {
            if (modalFile === singleFile) {
              setSingleFile(null);
            } else {
              const key = Object.keys(files).find((k) => files[k] === modalFile);
              setFiles((prev) => ({ ...prev, [key]: null }));
            }
            setModalShow(false);
          }}
        />
      </div>
    </section>
  );
};

export default Create_Step3;
